// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { JsonValueSchema } from '../inputTypeSchemas/JsonValueSchema'
import { ReportSourceSchema } from '../inputTypeSchemas/ReportSourceSchema'
import { ScheduledReportFrequencySchema } from '../inputTypeSchemas/ScheduledReportFrequencySchema'

/////////////////////////////////////////
// REPORT SCHEMA
/////////////////////////////////////////

export const ReportSchema = z.object({
  source: ReportSourceSchema,
  cadence: ScheduledReportFrequencySchema.nullable(),
  id: z.string(),
  tenantId: z.string().nullable(),
  applicationId: z.string(),
  applicationIds: z.string().array(),
  title: z.string(),
  nextStepsSummary: z.string().nullable(),
  relatedFindingsIds: z.string().array(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  contactName: z.string().nullable(),
  reportDate: z.coerce.date().nullable(),
  testPeriodStart: z.coerce.date().nullable(),
  testPeriodEnd: z.coerce.date().nullable(),
  exclusions: z.string().array(),
  limitations: z.string().array(),
  methodologyType: z.string(),
  scheduleRuleId: z.string().nullable(),
  scheduleSlotKey: z.string().nullable(),
  priorScheduledReportId: z.string().nullable(),
  changesSinceLast: JsonValueSchema.nullable(),
  pdfTemplateId: z.string().nullable(),
})

export type Report = z.infer<typeof ReportSchema>

export default ReportSchema;
